import React, { useState, useEffect } from "react";
import "../../styles/Header-css/Hedaer/LoginModal.css";
import playstore from "../../../assets/images/playstore.jpg";
import appstore from "../../../assets/images/playstore.jpg";

const LoginModal = ({ onClose, onLoginSuccess }) => {
  const [phone, setPhone] = useState("");
  const [step, setStep] = useState("login");
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(30);
  // OTP Timer
  useEffect(() => {
    let interval = null;
    if (step === "otp") {
      setTimer(30);
      interval = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [step]);

  const handleContinue = () => {
    if (step === "login" && phone.length >= 10) {
      setStep("otp");
    } else if (step === "otp") {
      // Simulate OTP verification success
      onLoginSuccess(); // Tell Menu to update state
    }
  };

  const handleOtpChange = (index, value) => {
    if (/^\d?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value && index < 5) {
        document.getElementById(`otp-${index + 1}`)?.focus();
      }
    }
  };

  return (
    <div className="login-modal-overlay">
      <div className="login-modal">
        <button className="close-btn" onClick={onClose}>×</button>

        <div className="modal-left">
          {step === "login" ? (
            <>
              <h1>Your services placed<br /> in 10 minutes</h1>
              <div className="phone-input">
                <span>+91</span>
                <input
                  type="tel"
                  placeholder="Enter Phone Number"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>
              <button
                className="continue-btn"
                disabled={phone.length < 10}
                onClick={handleContinue}
              >
                Continue
              </button>
              <a href="#" className="use-email-link">Use Email ID instead</a>
              <p className="terms">
                By continuing, you agree to our<br />
                <span>Terms of Service</span> &{" "}
                <span>Privacy Policy</span>
              </p>
            </>
          ) : (
            <>
              <button className="back-btn" onClick={() => setStep("login")}>←</button>
              <h2>OTP Verification</h2>
              <p>OTP has been sent to +91 {phone}</p>
              <div className="otp-inputs">
                {otp.map((digit, i) => (
                  <input
                    key={i}
                    id={`otp-${i}`}
                    type="text"
                    maxLength={1}
                    value={digit}
                    onChange={(e) => handleOtpChange(i, e.target.value)}
                  />
                ))}
              </div>
              <p className="timer">{`00:${timer.toString().padStart(2, "0")}`}</p>
              <a href="#" className="resend">
                Didn't get it? <strong>Send OTP (SMS)</strong>
              </a>
              <br />
              <button
                className="continue-btn"
                disabled={otp.some((val) => val === "")}
                onClick={handleContinue}
              >
                Continue
              </button>
            </>
          )}
        </div>

        <div className="modal-right">
          <h3>Order faster<br /> & easier everytime</h3>
          <p>with the R2R App</p>
          <div className="store-buttons">
            <img src={playstore} alt="Google Play" />
            <img src={appstore} alt="App Store" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
